import { writable } from 'svelte/store';
export const AuthUser = writable(null);
export const PageUrl = writable(null);

export const getUTCDate=(dateToChange)=>{
    const dt =new Date(dateToChange);
    let dd = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate();
    let   mm = (dt.getMonth() + 1 )< 10 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1;
    let  yyyy = dt.getFullYear();
    return new Date(Date.UTC(yyyy,mm-1,dd));
}

export const setCookie = (name,duration) => {  
    const dt=Date.now(); 
    document.cookie = `${name}=${dt}; expires=${duration};path=/;`;
}
export const getCookie = name =>{
    let cookies = document.cookie.split(";");  
    let cookieFound = cookies.find(c => c.includes(name));
    return cookieFound;
}

